import React from "react";
import Link from "components/link";
import { useSettings } from "hooks/useStore";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";
import clsx from "clsx/lite";
import HighlightMatch from "components/highlight-match";

const ProductSuggestions = ({ term, isMobile, toggleSearch, activeTab, query }) => {
	const showType =
		!term.title.toLowerCase().includes(query.toLowerCase()) &&
		term.type.toLowerCase().includes(query.toLowerCase());

	return (
		<>
			<div
				className="flex flex-col flex-wrap xxl:flex-row items-start xxl:gap-3 search-suggestions-v1">
				<Link
					className={clsx("text-black text-left mb-1 md:mb-0 capitalize", isMobile && "t-search-suggestion-click")}
					onClick={toggleSearch} to={`/search?q=${term.title}`} state={{ activeTab }}
				>
					{term.title}
				</Link>
			</div>
			<div
				className="flex flex-col flex-wrap xxl:flex-row items-start xxl:gap-3 search-suggestions-v2">
				<Link
					className={clsx("text-black text-left mb-1 md:mb-0 capitalize", isMobile && "t-search-suggestion-click")}
					onClick={toggleSearch} to={`/search?q=${term.title}`} state={{ activeTab }}
				>
					<HighlightMatch text={term.title} query={query} />
				</Link>
				{showType &&
					<Link
						className={clsx("text-gray-500 text-xs capitalize my-auto", isMobile && "t-search-suggestion-click")}
						onClick={toggleSearch} to={`/search?q=${term.type}`} state={{ activeTab }}
					>
						<HighlightMatch text={term.type} query={query} />
					</Link>
				}
			</div>
		</>
	);
};

const SearchSuggestions = ({ popularTerms = [], results, activeTab, query }) => {
	const { toggleSearch } = useSettings(["toggleSearch"]);
	const suggestions = results?.[activeTab] || popularTerms;
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });

	const displayCount = activeTab === "blogs" && isMobile ? 2 : isMobile ? 4 : 6;

	return (
		<div className="search-suggestions">
			{results && <p className="hidden md:flex !h-5 mb-1 search-t57" />}
			<span className="text-secondary">{results?.[activeTab] ? "Suggestions" : "Popular searches"}</span>
			{suggestions?.slice(0, displayCount).map((term, index) =>
				activeTab === "products" && results?.[activeTab] ? (
					<ProductSuggestions
						key={`${term.title}-${term.type}-${index}`}
						term={term} index={index} isMobile={isMobile}
						toggleSearch={toggleSearch} activeTab={activeTab}
						query={query}
					/>
				) : (
					<Link
						className={clsx("text-black text-left mb-1 md:mb-0 capitalize", isMobile && "t-search-suggestion-click")}
						key={`${term}-${index}`} onClick={toggleSearch} to={`/search?q=${term}`} state={{ activeTab }}
					>
						{term}
					</Link>
				)
			)}
		</div>
	);
};

export default SearchSuggestions;